<template>
    <div class="pic-wrap">
        <el-row :gutter="20">
            <el-descriptions class="margin-top" border>
                <el-descriptions-item label="优惠券发放设置">绑定优惠券/余额</el-descriptions-item>
            </el-descriptions>
        </el-row>
        <el-row :gutter="20">
            <el-table :data="list" stripe border center v-loading="loading">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="id" label="id" width="170"></el-table-column>
                <el-table-column prop="ticketBatchName" label="优惠券批次"></el-table-column>
                <el-table-column prop="count" label="优惠券数量" width="150"></el-table-column>
                <el-table-column prop="balance" label="余额(元)" width="150">
                    <!--<template slot="header" slot-scope="scope">-->
                    <!--<el-input-number v-model="scope.row.balance" :min="0" :max="50"-->
                    <!--label="元"></el-input-number>-->
                    <!--</template>-->
                </el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot="header" slot-scope="scope">
                        操作

                        <el-button type="primary" size="mini" @click="goBindCoupon">配置优惠券(余额)</el-button>
                        {{type}}发送

                    </template>
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="deleteOwnCoupon(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-dialog title="绑定优惠券" :visible.sync="showDialog">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="4">
                            已选择:<b>{{voList.length}}</b>张

                        </el-col>
                        <el-col offset="16" :span="4">
                            <el-button type="primary" size="small" @click="saveActiveCoupon">保存</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-table :data="voList" stripe border center v-loading="loading">
                            <el-table-column type="index" label="序号" width="50"></el-table-column>
                            <el-table-column prop="ticketBatchName" label="优惠券批次"></el-table-column>
                            <el-table-column prop="count" label="优惠券数量" width="150">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.count" :min="0" :max="50"
                                                     label="张"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column prop="balance" label="余额(元)" width="150">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.balance" :min="0" :max="50"
                                                     label="元"></el-input-number>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="danger" size="mini" @click="deleteCoupon(scope.row.index)">删除


                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="优惠券批次名称">
                            <el-input v-model="formInline.ticketBatchName" placeholder="优惠券批次名称"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getEnableCashticketList">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="success" @click="add">仅送余额</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table :data="cashticketList" stripe border center v-loading="loading">
                        <el-table-column type="index" label="序号" width="50"></el-table-column>
                        <el-table-column prop="ticketBatchName" label="优惠券批次"></el-table-column>
                        <el-table-column prop="amount" label="金额/折扣"></el-table-column>
                        <el-table-column prop="createTime" label="创建时间"></el-table-column>
                        <el-table-column prop="userName" label="创建人"></el-table-column>
                        <el-table-column label="操作" fixed="right" width="120">
                            <template slot-scope="scope">
                                <el-button type="success" size="mini" @click="selectCoupon(scope.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination-wrap">
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="formInline.currentPage"
                                :page-sizes="GCONFIG.pageSizes"
                                :page-size="formInline.pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="formInline.recordsTotal">
                        </el-pagination>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    import draggable from 'vuedraggable'
    import {
        getCashticketListByBindCodeApi,
        saveActiveCouponApi,
        getEnableCashticketListApi,
        deleteCouponConfigApi
    } from '@/api/api'
    import ElRow from "element-ui/packages/row/src/row";
    export default{
        data(){
            return {
                bindCode: this.$route.query.bindCode,
                sourceName: this.$route.query.sourceName || this.$route.query.activeName,// 优惠券挂载来源
                type: this.$route.query.type,//
                loading: true,
                list: [],
                formInline: {
                    ticketBatchName: "",
                    platformId: 1,
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0
                },
                showDialog: false,
                cashticket: {count: 0, ticketBatchName: '', balance: 0, ticketBatchId: ''},
                voList: [],//选择的优惠券
                cashticketList: [] //所有优惠券
            }
        },
        computed: {},
        components: {
            //picDialog,
            ElRow, draggable
        },
        mounted(){
            this.getCashticketListByBindCode();
        },
        methods: {
            getCashticketListByBindCode(){
                //查询绑定优惠券、余额
                getCashticketListByBindCodeApi({"bindCode": this.bindCode}).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.list = res.data.value;
                        for (var i = 0; i < this.list.length; i++) {
                            var coupon = {};
                            coupon.count = this.list[i].count;
                            coupon.ticketBatchName = this.list[i].ticketBatchName;
                            coupon.ticketBatchId = this.list[i].ticketBatchId;
                            coupon.balance = this.list[i].balance > 0 ? this.list[i].balance / 100 : 0;
                            this.list[i].balance = coupon.balance
                            //coupon.balance =this.list[i].balance
                            this.voList.push(coupon);
                        }
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            add(){
                this.voList.push(
                    {count: 0, ticketBatchName: '无', balance: 1, ticketBatchId: ''}
                );
            },
            goBindCoupon(){
                let routerL = '/' + this.$route.path.split('/')[1];
                this.$router.push({
                    path: routerL + '/picture/' + row.activeNo,
                    query: {picType: '15', picName: row.proName, picState: 'product'}
                })
            },
            changeListSort(evt){
                console.log(evt.moved)
                let moveItem = evt.moved;
                this.$store.dispatch('changePicListSort', {
                    picId: moveItem.element.picId,
                    sort: moveItem.newIndex + 1,
                    proId: this.$route.params.id,
                    picType: this.activeNo
                })
            },
            getEnableCashticketList(){
                //查询绑定优惠券、余额
                getEnableCashticketListApi(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.cashticketList = res.data.value.list;
                        this.formInline.recordsTotal = res.data.value.total;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            goBindCoupon(){
                //显示绑定券模态窗口
                this.showDialog = true;
                this.getEnableCashticketList();
            },
            selectCoupon(row){
                for (var i = 0; i < this.voList.length; i++) {
                    if (this.voList[i].ticketBatchName === row.ticketBatchName) {
                        this.$message({
                            showClose: true,
                            message: row.ticketBatchName + '优惠券已存在',
                            type: 'error'
                        });
                        return;
                    }
                }
                //选择优惠券
                let coupon = {};
                coupon.count = 1;
                coupon.ticketBatchName = row.ticketBatchName;
                coupon.ticketBatchId = row.ticketBatchId;
                coupon.balance = 0;
                this.voList.push(coupon);
            },
            deleteOwnCoupon(row){
                this.$confirm('删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteCouponConfigApi({id: row.id}).then((res) => {
                        if (res.data.status == 200) {
                            this.getCashticketListByBindCode();
                        } else {
                            this.$message({
                                showClose: true,
                                message: '删除失败',
                                type: 'error'
                            });
                        }
                    });
                });
            },
            deleteCoupon(index){
                this.voList.splice(index, 1)
            },
            saveActiveCoupon(){
                for (var i = 0; i < this.voList.length; i++) {
                    if (this.voList[i].count === 0 && this.voList[i].count) {
                        this.$message({
                            showClose: true,
                            message: '优惠券张数和余额不能同时0',
                            type: 'error'
                        });
                        return;
                    }
                }
                this.voList.forEach(c => {
                    c.balance = c.balance * 100
                })
                this.loading = true;
                saveActiveCouponApi({
                    bindCode: this.bindCode,
                    list: encodeURIComponent(JSON.stringify(this.voList))
                }).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        this.voList = [];
                        this.getCashticketListByBindCode();
                        this.showDialog = false;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getEnableCashticketList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getEnableCashticketList();
            },
            returnHistory(){
                window.history.back();
            }
        }
    }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
    .pic-wrap {
        padding: 10px;
    }

    .header-return {
        margin-bottom: 20px;
        border-bottom: 1px solid #eeeeee;
        padding-bottom: 10px;
        position: relative;
        h2 {
            text-align: center;
            position: absolute;
            left: 50%;
            top: 0;
            margin: 0;
        }
    }

    .pic-btn-wrap {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        p {
            color: #e50011;
            font-size: 20px;
            margin: 0;
        }
    }

    .header-btn {
        margin-left: 20px;
        font-size: 24px;
        font-weight: bold;
        padding: 5px 10px;
    }

    .drag-container {
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #606266;
        border-spacing: 0;
        border-collapse: collapse;
        img {
            width: 70px;
            height: 70px;
        }
        td, th {
            padding: 12px 0;
            border: 1px solid #EBEEF5;

        }
        th {
            background: #eef1f6;
            color: #222222;
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/coupon/coupon.vue